import { queryFeatures, IQueryFeaturesResponse } from '@esri/arcgis-rest-feature-layer';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';

import { SnLayer } from '@lib/api/entities';

import { arcgisToGeoJSON, arcgisAttributesToProperties } from '../helpers';
import { IFeatureSet } from '../interfaces';
import { Query } from '../tasks';

export class FeatureLayer {
  private _query: Query;

  constructor(public readonly url: string) {
    this._query = new Query();
  }

  public getQuery(): Query {
    return this._query;
  }

  public queryFeatures(query: Query = this._query, layer: SnLayer): Observable<IFeatureSet> {
    this._query = query;

    const request = queryFeatures({
      url: this.url,
      ...this._query.toJSON(),
      returnIdsOnly: false,
      returnGeometry: true,
      returnCountOnly: false,
      returnExtentOnly: false,
    });

    return from(request).pipe(
      map((response: IQueryFeaturesResponse) => {
        const objectIdFieldName =
          layer.meta?.objectIdFieldName || this._getObjectIdFieldName(response);

        const features = response.features
          .map((arcgisFeature: any) => {
            const feature: any = arcgisToGeoJSON(arcgisFeature, objectIdFieldName);
            feature.properties = arcgisAttributesToProperties(feature.properties, response.fields);
            if (arcgisFeature?.applianceId) {
              feature.properties.applianceId = arcgisFeature.applianceId;
            }
            return feature;
          })
          .filter((feature) => feature.geometry);

        return { ...response, features };
      }),
    );
  }

  private _getObjectIdFieldName(response: IQueryFeaturesResponse): string | null {
    const esriFieldTypeOID = response.fields.find((field) => {
      return field.type === 'esriFieldTypeOID';
    });

    return response.objectIdFieldName || esriFieldTypeOID?.name;
  }
}
